import { ErrorKinds } from "./errorKinds.js";

const ADMIN_EMAIL = "registrace@b7id.cz";
const CONTACT_FALLBACK = `Pokud se chyba opakuje, kontaktujte správce aplikace na ${ADMIN_EMAIL}.`;

const COPY = {
  [ErrorKinds.connectivity]: {
    alert: {
      title: "Problém s připojením",
      message: "Nepodařilo se spojit se serverem. Zkontrolujte připojení k internetu a zkuste to znovu.",
    },
    spa: {
      title: "Problém s připojením",
      message:
        "Nepodařilo se načíst obsah kvůli problému s připojením.\n\nZkontrolujte internetové připojení a obnovte stránku.",
    },
  },
  [ErrorKinds.temporaryInfra]: {
    alert: {
      title: "Dočasný problém serveru",
      message: `Služba je dočasně nedostupná. Zkuste to prosím znovu za chvíli. ${CONTACT_FALLBACK}`,
    },
    spa: {
      title: "Dočasný problém serveru",
      message: `Při načítání obsahu došlo k dočasné nedostupnosti služby.\n\nZkuste obnovit stránku za chvíli.\n\n${CONTACT_FALLBACK}`,
    },
  },
  [ErrorKinds.unexpectedApp]: {
    alert: {
      title: "Neočekávaná chyba",
      message: `Při běhu aplikace nastala neočekávaná chyba. Zkuste obnovit stránku. ${CONTACT_FALLBACK}`,
    },
    spa: {
      title: "Neočekávaná chyba",
      message: `Při načítání obsahu došlo k neočekávané chybě.\n\nMožná jsme vám právě nasadili novou funkcionalitu.\nZkuste obnovit stránku.\n\n${CONTACT_FALLBACK}`,
    },
  },
  [ErrorKinds.forbidden]: {
    alert: {
      title: "Nedostatečné oprávnění",
      message: "K požadované funkčnosti nemáte dostatečné oprávnění.",
    },
    spa: {
      title: "Nedostatečné oprávnění",
      message: "K požadované funkčnosti nemáte dostatečné oprávnění.",
    },
  },
};

/**
 * User-facing Czech copy for a classified generic error.
 *
 * @param {typeof ErrorKinds[keyof typeof ErrorKinds]} kind
 * @param {{ surface?: "alert" | "spa" }} [options]
 * @returns {{ title: string, message: string }}
 */
export function getGenericErrorCopy(kind, options = {}) {
  const surface = options.surface === "spa" ? "spa" : "alert";
  const entry = COPY[kind] ?? COPY[ErrorKinds.unexpectedApp];
  return entry[surface];
}
